/* ============
 * Dashboard
 * ============
 *
 * This is the dashboard page.
 */

import { mapGetters, mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import modulesService from './../../services/modules';
import accountService from './../../services/account';
import warehouseService from '../../services/warehouse';

export default {
  props: {
    mod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: new Forms({
        websiteUrl: {
          type: 'text',
          value: '',
        },
      }),
      token: '',
      loading: false,
      generateTokenLoading: false,
      backendUrl: process.env.API_LOCATION,
    };
  },

  computed: {
    ...mapGetters({
      account: 'account',
    }),
  },

  mounted() {
    this.show();
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalShowClose: 'SET_MODAL_SHOW_CLOSE',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalClass: 'SET_MODAL_CLASS',
    }),

    show() {
      Promise.all([
        accountService.wordpressCredentials(),
        accountService.find(),
      ]).then((data) => {
        this.form.websiteUrl = data[0].websiteUrl;
        this.token = data[0].token;
      });
    },

    store() {
      const params = {
        module_id: this.mod.id,
        is_wordpress_api: true,
        website_url: this.form.websiteUrl,
      };
      modulesService.subscribe(this.mod.id, params).then(() => {
        Promise.all([modulesService.items(), accountService.find()]);
        this.closeModal();
      });
    },

    copyToken() {
      const tokenInput = this.$refs.tokenInput;
      tokenInput.select();
      document.execCommand('copy');
    },

    generateToken() {
      this.generateTokenLoading = true;
      accountService
        .wordpressGenerateToken()
        .then((result) => {
          this.token = result.token;
          this.generateTokenLoading = false;
        }).catch(() => {
          this.generateTokenLoading = false;
        });
    },

    /*
     * Closes the modal
     */
    closeModal() {
      this.toggleModal(false);
      this.unsetModalContent();
    },
  },
  components: {
    VForm: require('./../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/wordpressCredentialsModal/wordpressCredentialsModal.js